module.exports = __webpack_public_path__ + "fonts/NespressoLucas-XtraBd.woff2?v=bdc29d0e6f4aa20c2b6449dbeabba60c";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/nespresso-lucas/NespressoLucas-XtraBd.woff2
// module id = 684
// module chunks = 0